import { IFormControlClassGroup } from "./FormControlClassGroup.types";
import { ClassGroupType } from "../../Style.types";

export const FormControlClassGroup: ClassGroupType<IFormControlClassGroup> = {
  formGroup: {
    display: "flex",
    flexDirection: "column",
    rowGap: 12,
  },
  formControl: {
    display: "flex",
    flexDirection: "row",
    gap: 4,
  },
  formCheck: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  formLabel: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  formControlLabel: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  formControlInput: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  formControlError: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  isValid: (theme) => ({
    color: theme.colors.success.main,
  }),
  isInvalid: (theme) => ({
    color: theme.colors.danger.main,
  }),
  textDanger: (theme) => ({
    color: theme.colors.danger.main,
  }),
};
